import type {FC} from 'react';
import * as React from "react";
import Chart from 'react-apexcharts';
import { Box, styled, Typography } from "@mui/material";
import {useTheme} from '@mui/material/styles';
import {ApexOptions} from "apexcharts";
import currencySwitcher from "../../../../../../utils/currencySwitcher";
import { useMainContext } from "../../../../../../contexts/MainContext";
import { useKeystoneContext } from "../../../../../../contexts/KeystoneContext";
import { useNavigate } from "react-router-dom";
import { FilterItem } from "../../../../../../cog/keystone/filter/Filter";
import { Filter as FilterObject, FilterStore } from "../../../../../../cog/keystone/filter";
import { useContext } from "react";
import SettingsContext from "../../../../../../contexts/SettingsContext";

const StyledBox = styled('div')(({theme}) => ({
  [theme.breakpoints.up('sm')]: {
    minHeight: 500,
    minWidth: 500
  },
  [theme.breakpoints.down('sm')]: {
    minHeight: 400,
    minWidth: 300
  }
}));

interface LandingPieProps {
  series: number[];
  labels: string[];
  header: string;
}

const LandingPie: FC<LandingPieProps> = ({series, labels, header}) => {
  const chartType = "pie"
  const mainCtx = useMainContext()
  const keystoneCtx = useKeystoneContext()
  const settingsCtx = useContext(SettingsContext)
  const navigate = useNavigate()

  const updateFilter = async () => {
    keystoneCtx.RefreshCards()
    const org = mainCtx.activeOrganization.name.replace(/ |_/g,'-');
    navigate("/app/" + org.toLowerCase() + "/opportunities")
  }

  const chartOptions: ApexOptions = {
    chart: {
      type: "line",
      foreColor: useTheme().palette.text.primary,
      width: 500,
      height: 500,
      events: {
        dataPointSelection(event, chartContext, config) {
          const OppTypeFilter: FilterItem = {
            header: "opportunity_type",
            operation: "=",
            prefix: "AND",
            values: "Distribution"
          }

          const seriesFilter: FilterItem = {
            header: header,
            operation: "=",
            prefix: "AND",
            values: labels[config.dataPointIndex]
          }

          const filters: FilterItem[] = []
          filters.push(OppTypeFilter, seriesFilter)

          const filteredFilter = filters.filter((f) => !f.level)
          const filteredWithDefault = filteredFilter.concat(keystoneCtx.filters)

          keystoneCtx.setClickThroughFilters(filteredWithDefault)
          // keystoneCtx.setFlipSwitchForCards(!keystoneCtx.flipSwitchForCards)
          updateFilter()
        }
      }
    },
    labels: labels,
    dataLabels: {
      formatter: function (val, opt) {
        return series[opt.seriesIndex]
      },
    },
    colors: ["#4b4b4b", "#f2bc53", "#f45c5c", "#e1d5c6", "#8c9494"],
    tooltip: {
      y: {
        formatter: function (val) {
          return "Opportunities: " + val.toString()
        }
      },
      theme: settingsCtx.settings.theme === 'LIGHT' ? 'light' : 'dark'
    },
    legend: {
      // offsetY: 200,
      // offsetX: 50,
      position: 'right'
    },
    responsive: [{
      breakpoint: 480,
      options: {
        legend: {
          // show: false
        },
      }
    }]
  };

  if (series != null) {
    return (
      <StyledBox>
        <Chart
          type={chartType}
          series={series}
          options={chartOptions}
          height={"100%"}
          width={"100%"}
        />
      </StyledBox>
    );
  } else {
    return (
      <StyledBox>
        <Typography>
          No Data To Display
        </Typography>
      </StyledBox>
    );
  }

};

export default LandingPie;